import React from 'react';
import PropTypes from 'prop-types';
import { FaFileText } from 'react-icons/lib/fa';
import { TiDelete } from 'react-icons/lib/ti';

import { apiDeleteFile } from '../../api/media';
import { handleErrorBase } from '../../util/forms';

const propTypes = {
  fake: PropTypes.bool,
  file: PropTypes.object,
  onDelete: PropTypes.func,
};

const File = ({ fake, file, onDelete }) => {
  const Component = file.url ? 'a' : 'div';

  return (
    <Component className="badge badge-primary mx-1 my-1" href={file.url} target="_blank">
      <FaFileText className="mr-2" />
      {file.name}
      {onDelete && (
        <TiDelete
          className="ml-2"
          onClick={(e) => {
            e.preventDefault();

            if (fake) {
              onDelete();
            } else {
              apiDeleteFile(file.id)
                .then(onDelete)
                .catch(() => handleErrorBase('Could not delete file.'));
            }
          }}
        />
      )}
    </Component>
  );
};

File.propTypes = propTypes;

export default File;
